import getConfig from 'next/config';
const {
  publicRuntimeConfig
} = getConfig();
// 从环境变量中取MODE，配置在next.config.js和package.json文件中
const ENV = publicRuntimeConfig.env.NEXT_PUBLIC_ENV;
const version = process.env.npm_package_version || require('../package.json').version;

import * as Sentry from "@sentry/react";
import {
  BrowserTracing
} from "@sentry/tracing";

// 只有生产环境才执行
const sentry = function () {
  // Sentry.init({
  //   // enabled: ENV === 'production',
  //   release: version, // 版本号，sourceMap上传后，可以点击版本号查看不同版本的错误信息
  //   // dsn: "https://9175e357ba5549e4a928b7b892fb7f9d@sentry.lianlianpay.com/39",
  //   // integrations: [new BrowserTracing()],
  //   // environment: ENV,
  //   // // Set tracesSampleRate to 1.0 to capture 100%
  //   // // of transactions for performance monitoring.
  //   // // We recommend adjusting this value in production
  //   // tracesSampleRate: 1.0,
  //   dsn: "https://bb27253ca6c4a6ad6164e81002ffc73c@sentry.lianlianpay.com/48",
  //   integrations: [
  //     Sentry.browserTracingIntegration(),
  //     Sentry.replayIntegration(),
  //   ],
  //   // Performance Monitoring
  //   tracesSampleRate: 1.0, //  Capture 100% of the transactions
  //   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  //   tracePropagationTargets: ["localhost", /^https:\/\/secure-checkout.lianlianpay-inc.com/, /^https:\/\/gacashier.lianlianpay-inc.com/],
  //   // Session Replay
  //   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  //   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  // });
  Sentry.init({
    dsn: "https://8f479a7792881530cf5b7a0b0973523f@ll-sentry.lianlianpay.com/10",
    // integrations: [new BrowserTracing()],
    environment: ENV,
    release: version,
    dist: version,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        mask: [".mask-me"],
        unmask: [".unmask-me"],
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    // 使用数组定义要忽略的错误
    ignoreErrors: [
      "t is not a function. (In 't()', 't' is undefined)",
      "Can't find variable: pageHiddenToOthersPage",
      "Can't find variable: pageHiddenToBackend", 
      "Can't find variable: pageVisibleFromBackend",
      "Can't find variable: pageVisibleFromOthersPage",
      "Failed to fetch",//浏览器自动取消（页面卸载时浏览器会取消未完成的请求，用户切换页面或刷新）
      "Network connection is disconnected",//网络有误
      "Load failed",
    ],
  });
};

module.exports.sentry = sentry;
